import React, { useState } from "react";
import Navbar from "./components/navbar";
import styled from "styled-components";
import { ReactComponent as StarField } from "images/svg/starfield.svg";
import { ReactComponent as BgSvgMobile } from "images/svg/reset-mobile-starfield.svg";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import TextInput from "components/inputs/text-input";
import PrimaryButton from "components/buttons/primary-button";
import { Link, useNavigate } from "react-router-dom";
import Toast from "components/toast";
import api from "services/axiosInstance";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const Confirm = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/password-reset-request", { email });
      Toast({ response: res });
      navigate("/forgot-password/reset");
    } catch (e) {
      Toast({ error: e, type: "error" });
    } finally {
      setLoading(false);
    }
  };
  return (
    <Container>
      <Navbar />
      <BG>
        <StarField />
      </BG>
      <MBg>
        <BgSvgMobile width={"100%"} height={"100%"} />
      </MBg>
      <Body onSubmit={Confirm}>
        <SvgContainer>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 64 64"
            fill="none"
          >
            <path
              d="M56.4272 11.9459C52.3164 9.57052 47.3995 8.38279 41.6641 8.37048C35.9349 8.37048 31.0241 9.5337 26.9441 11.8906C23.7995 13.706 21.8672 15.8659 21.1411 18.3705C20.9626 18.9921 20.8641 19.6074 20.8518 20.2167V20.7151C20.938 22.3828 21.6395 24.0013 22.9625 25.5706L22.1072 26.069H20.8518L15.7195 26.0566C15.2272 26.0566 14.7903 26.1058 14.4026 26.2105C14.0088 26.3151 13.6518 26.4629 13.3257 26.6537C12.9995 26.8445 12.7472 27.0476 12.5626 27.2753C12.378 27.4968 12.2918 27.749 12.2918 28.0321L12.3103 31.7244L4.63643 32.2413C4.1872 32.2659 3.75641 32.3337 3.35026 32.4506C2.93795 32.5675 2.59337 32.7337 2.30414 32.9429C2.02106 33.1583 1.81795 33.3797 1.69488 33.6197C1.61488 33.7674 1.57182 33.9274 1.55951 34.0874V34.1552C1.55951 34.2229 1.56564 34.2966 1.57795 34.3643L2.4149 41.2075C2.45182 41.466 2.56874 41.7121 2.75336 41.9336C2.93797 42.1613 3.19643 42.3705 3.52259 42.5551C3.85489 42.7459 4.21182 42.8814 4.59951 42.9676C4.99336 43.0476 5.39336 43.0906 5.79952 43.0906L10.8395 43.1029C11.3257 43.1029 11.7872 43.0536 12.218 42.9429C12.2488 42.9367 12.2795 42.9306 12.3041 42.9183C12.698 42.8198 13.0488 42.6783 13.3503 42.506L20.5072 38.3705L22.458 37.2444L31.3318 32.1182L32.8211 31.2629C36.5934 32.309 40.6611 32.666 45.018 32.3336C47.4241 32.149 49.6703 31.7244 51.7564 31.0537C53.4487 30.5183 55.0364 29.8229 56.5195 28.9676C57.7811 28.2414 58.8457 27.466 59.7134 26.6475C61.6455 24.826 62.6117 22.7766 62.6117 20.512V20.469C62.5932 17.1583 60.5318 14.3151 56.4272 11.9459ZM51.7564 22.1798C51.2887 23.1152 50.4088 23.9521 49.1226 24.6967C47.0857 25.8782 44.6303 26.4629 41.7626 26.4567C38.8949 26.4506 36.4395 25.8535 34.3841 24.672C33.0733 23.9151 32.1749 23.0597 31.7011 22.1059C31.4303 21.5705 31.2949 21.0044 31.2888 20.4074C31.2826 18.7521 32.298 17.3367 34.3349 16.1613C36.378 14.9798 38.8334 14.3951 41.6949 14.4013C44.5626 14.4074 47.0241 14.9983 49.0795 16.186C51.1288 17.3737 52.1626 18.7952 52.1688 20.4444C52.1749 21.0537 52.0395 21.6321 51.7564 22.1798Z"
              fill="#FFE8A6"
              stroke="#FFBE00"
              stroke-width="1.23077"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M52.1685 20.4444C52.1746 21.0536 52.0392 21.6321 51.7562 22.1798C51.2885 23.1152 50.4085 23.9521 49.1223 24.6967C47.0854 25.8782 44.63 26.4629 41.7623 26.4567C38.8946 26.4506 36.4392 25.8535 34.3839 24.672C33.0731 23.9151 32.1746 23.0598 31.7008 22.1059C31.43 21.5705 31.2946 21.0044 31.2885 20.4074C31.2823 18.7521 32.2977 17.3367 34.3346 16.1614C36.3777 14.9798 38.8331 14.3951 41.6946 14.4013C44.5623 14.4074 47.0239 14.9983 49.0792 16.186C51.1285 17.3737 52.1623 18.7951 52.1685 20.4444Z"
              fill="#FFE8A6"
              stroke="#FFBE00"
              stroke-width="1.23077"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M32.8211 31.2628V43.5705L13.3503 54.8137C13.0241 54.9983 12.6488 55.1459 12.218 55.2505C11.7872 55.3613 11.3257 55.4105 10.8395 55.4105L5.79952 55.3982C5.39336 55.3982 4.99336 55.3552 4.59951 55.2752C4.21182 55.189 3.85489 55.0535 3.52259 54.8628C3.19643 54.6781 2.93797 54.4689 2.75336 54.2412C2.56874 54.0197 2.45182 53.7736 2.4149 53.5151L1.57795 46.6719C1.56564 46.6104 1.55951 46.5367 1.55951 46.4751V34.1551C1.55951 34.2228 1.56564 34.2965 1.57795 34.3642L2.4149 41.2074C2.45182 41.4659 2.56874 41.712 2.75336 41.9335C2.93797 42.1612 3.19643 42.3704 3.52259 42.5551C3.85489 42.7458 4.21182 42.8813 4.59951 42.9675C4.99336 43.0475 5.39336 43.0905 5.79952 43.0905L10.8395 43.1028C11.3257 43.1028 11.7872 43.0536 12.218 42.9428C12.2488 42.9367 12.2795 42.9305 12.3041 42.9182C12.698 42.8197 13.0488 42.6783 13.3503 42.506L20.5072 38.3704L22.458 37.2444L31.3318 32.1181L32.8211 31.2628Z"
              fill="#FFE8A6"
              stroke="#FFBE00"
              stroke-width="1.23077"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M62.6117 20.512V32.7767C62.6302 36.0813 60.5994 38.9183 56.5194 41.2752C53.2086 43.1829 49.3809 44.3029 45.0178 44.6413C40.6609 44.9736 36.5932 44.6167 32.8209 43.5705V31.2629C36.5932 32.309 40.6609 32.6659 45.0178 32.3336C47.424 32.149 49.6702 31.7244 51.7563 31.0536C53.4486 30.5182 55.0363 29.8229 56.5194 28.9675C57.7809 28.2414 58.8455 27.4659 59.7132 26.6475C61.6455 24.8259 62.6117 22.7766 62.6117 20.512Z"
              fill="#FFE8A6"
              stroke="#FFBE00"
              stroke-width="1.23077"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M22.9623 25.5707L22.1069 26.0691H20.8516V20.7152C20.9377 22.3829 21.6393 24.0014 22.9623 25.5707Z"
              fill="#FFE8A6"
              stroke="#FFBE00"
              stroke-width="1.23077"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M20.8516 20.2166V19.989V20.2166Z" fill="#FFE8A6" />
            <path
              d="M20.8516 20.2166V19.989"
              stroke="#FFBE00"
              stroke-width="1.23077"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </SvgContainer>
        <Typography
          size="4xl"
          weight="semibold"
          mb="0.8"
          color={Colors.white100}
        >
          Forgot Password
        </Typography>
        <Typography mb="2.4" color={Colors.grey400}>
          Enter your email address below. We'll send you a link to reset your
          password.
        </Typography>
        <TextInput
          required
          label="Email"
          placeholder="example@gmail.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button>
          <PrimaryButton text="Reset" inset type="submit" loading={loading} />
        </Button>
        <FooterContainer>
          <span style={{ display: "inline-flex" }}>
            <Typography mr="0.5" size="s" color={Colors.grey500}>
              Don’t have an account?
            </Typography>
            <TextLink to={"/create-account"}>
              <Typography
                color={Colors.yellow400}
                size="s"
                decoration="underline"
              >
                Register
              </Typography>
            </TextLink>
          </span>
        </FooterContainer>
      </Body>
    </Container>
  );
};

export default ForgotPassword;

const Container = styled.main`
  width: 100%;
  height: 100%;
  position: relative;
`;

const BG = styled.div`
  position: absolute;
  width: 100%;
  left: -8.2%;
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;

const MBg = styled.div`
  display: none;
  width: 100%;
  position: absolute;
  height: fit-content;

  @media only screen and (max-width: 769px) {
    display: block;
  }
`;

const Body = styled.form`
  width: 58rem;
  padding: 1.6rem;
  margin-left: auto;
  margin-right: auto;
  margin-top: 13.3rem;
  border-radius: 0.8rem;
  border: 1px solid #4e4c44;
  background: rgba(30, 30, 30, 0.8);
  position: relative;
  text-align: center;
  @media only screen and (max-width: 769px) {
    width: 90%;
  }
`;

const SvgContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  margin-top: 1.6rem;
  margin-bottom: 2.4rem;
  width: 6.4rem;
  height: 6.4rem;
`;

const Button = styled.div`
  margin-top: 2.4rem;
`;

const TextLink = styled(Link)`
  all: unset;
  cursor: pointer;
`;

const FooterContainer = styled.div`
  margin-top: 2rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
